import { MessageReport } from "../../../../../../components/Messages";

const Report = () => {
  return <MessageReport />;
};

export default Report;
